// extracted by mini-css-extract-plugin
export default {"div_mdl":"Pay_div_mdl__48eFv","header":"Pay_header__vHSmU","model_button":"Pay_model_button__dypde","bdy":"Pay_bdy__L1l2T"};